import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Drawer from '../ui/Drawer';
import './MobileMenu.css';

const navLinks = [
  { label: 'Art', href: '/art' },
  { label: 'Fragrance', href: '/fragrance' },
  { label: 'Body', href: '/body' },
  { label: 'Music', href: '/music' },
  { label: 'Events', href: '/events' },
  { label: 'About', href: '/about' },
];

interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ open, onClose }) => {
  const location = useLocation();

  return (
    <Drawer open={open} onClose={onClose} side="left" label="Navigation menu">
      <div className="mobile-menu">
        <div className="mobile-menu__header">
          <Link to="/" className="mobile-menu__wordmark" onClick={onClose}>
            Micah Lynise
          </Link>
          <button className="mobile-menu__close" onClick={onClose} aria-label="Close menu">
            <CloseIcon />
          </button>
        </div>

        <nav className="mobile-menu__nav" aria-label="Main navigation">
          <ul className="mobile-menu__list">
            {navLinks.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className={`mobile-menu__link ${location.pathname.startsWith(link.href) ? 'mobile-menu__link--active' : ''}`}
                  onClick={onClose}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="mobile-menu__utils">
          <Link to="/search" className="mobile-menu__util-link" onClick={onClose}>
            <SearchIcon />
            Search
          </Link>
          <Link to="/cart" className="mobile-menu__util-link" onClick={onClose}>
            <CartIcon />
            Cart
          </Link>
        </div>
      </div>
    </Drawer>
  );
};

/* ─── Inline SVG icons ──────────────────────────────────────────────────────── */
const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const CartIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <path d="M16 10a4 4 0 0 1-8 0" />
  </svg>
);

export default MobileMenu;
